import common from '@/services/common'

export default {
  getBetaFiles(path) {
    return common.execute('get', `/api/client-content/v1/beta/files/${path}`).then(
      result => result.files,
    )
  },
  getFiles(path) {
    return common.execute('get', `/api/client-content/v1/files/${path}`).then(
      result => result.files,
    )
  },
  deleteBetaFile(path) {
    return common.execute('delete', `/api/client-content/v1/beta/files/${path}`)
  },
  deleteFile(path) {
    return common.execute('delete', `/api/client-content/v1/files/${path}`)
  },
  createBetaFolder(path) {
    return common.execute('post', `/api/client-content/v1/beta/folders/${path}`)
  },
  createFolder(path) {
    return common.execute('post', `/api/client-content/v1/folders/${path}`)
  },
  deleteBetaFolder(path) {
    return common.execute('delete', `/api/client-content/v1/beta/folders/${path}`)
  },
  deleteFolder(path) {
    return common.execute('delete', `/api/client-content/v1/folders/${path}`)
  },
  getBetaFolders(path) {
    return common.execute('get', `/api/client-content/v1/beta/folders/${path}`).then(
      result => result.folders,
    )
  },
  getFolders(path) {
    return common.execute('get', `/api/client-content/v1/folders/${path}`).then(
      result => result.folders,
    )
  },
  publishToProduction() {
    return common.execute('post', '/api/client-content/v1/publish')
  },
}
